import { ThemeUIStyleObject } from 'theme-ui';

export const pageStyles: ThemeUIStyleObject = {
  backgroundColor: 'neutral/100',
  minHeight: `calc(100vh - 4rem)`,
  flexDirection: 'column',
};

export const contentStyles: ThemeUIStyleObject = {
  flex: 1,
  width: '100%',
  margin: '0 auto',
  padding: ['1rem', '2rem 5rem'], // mobile, desktop
};
